<template>
  <div>
    <v-snackbar
      v-model="snackbar"
      color="primary"
      :timeout="2000"
      location="bottom right"
    >
      <v-icon size="xx-large">mdi-content-save</v-icon>
      <h3>{{ $t("basics.saved") }}!</h3>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  name: "saveDisplay",

  props: ["showSaveDisplay"],

  data() {
    return {
      snackbar: false,
    };
  },

  watch: {
    showSaveDisplay() {
      this.snackbar = true;
    },
  },
};
</script>
